<template>
  <div class="input checkbox-input" :class="{checked: checked}" @click.passive="toggle">
    <div class="checkbox--container">
      <div class="checked-status"></div>
    </div>
    <div class="checkbox--label">
      {{$t('card-payment-modal.cgv.0')}} <span @click.stop="openCgv">{{$t('card-payment-modal.cgv.1')}}</span> {{$t('card-payment-modal.cgv.2')}}
    </div>
  </div>
</template>

<script>
import CheckboxInput from "./checkbox-input";
export default {
  name: 'cgv-input',
  // extends: [CheckboxInput],
  mixins: [CheckboxInput],
  props: {
    label: String,
    defaultChecked: Boolean,
    htmlNeeded: Boolean,
    value: Boolean
  },
  methods: {
    openCgv () {
      this.$store.dispatch('legalModal/fetch');
      this.$store.commit('legalModal/SET_TAB', 1);
      this.$store.commit('legalModal/OPEN_MODAL');
    }
  }
};
</script>


<style scoped>

.orange {
  color: var(--orange);
  transition: All 0.3s ease-in-out;
  -webkit-transition: All 0.3s ease-in-out;
  -moz-transition: All 0.3s ease-in-out;
  -o-transition: All 0.3s ease-in-out;
  -ms-transition: All 0.3s ease-in-out;
}

a {
  text-decoration: none;
  color: var(--darker-orange);
}


.checkbox-input {
  display: flex;
  flex-wrap: nowrap;
  cursor: pointer;
  margin-top: 20px;
}
.checkbox-input .checkbox--container {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  margin: auto 1rem auto 0;
  background: var(--white);
  position: relative;
  border: 1px solid var(--black);
}
.checkbox-input .checkbox--container .checked-status {
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  background: var(--darker-orange);
  transform: scale(0);
  transition: all 300ms ease;
}
.checkbox-input.checked .checkbox--container .checked-status {
  transform: scale(1);
}
.checkbox-input .checkbox--label {
  flex: 1 1 auto;
  margin: auto auto auto 0;
  line-height: 16px;
}
.checkbox-input .checkbox--label span {
  color: var(--darker-orange);
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/cgv-input.vue